import { SxProps } from '@mui/material';

export const breadcrumbTextSX: SxProps = {
	fontSize: 'var(--font-size-small)',
	fontWeight: 'normal',
	color: '#929292',
};

export const breadcrumbTextLinkedSX: SxProps = {
	fontSize: 'var(--font-size-small)',
	fontWeight: 'normal',
	color: '#929292',
	textDecoration: 'none',
	'&:hover': {
		color: '#2c2c2c',
	},
};
